module.exports = __webpack_public_path__ + "assets/img/InstagramH.ca775b7b.png";